import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'sms4.settings.communication.notifications.earlySettings' }),

    description: translate({
      id: 'sms4.settings.communication.notifications.earlySettings.description',
    }),

    disableDescription: translate({
      id: 'sms4.settings.communication.notifications.earlySettings.toggle.disable',
    }),

    enableDescription: translate({
      id: 'sms4.settings.communication.notifications.earlySettings.toggle.enable',
    }),
  }))

  return api
}
